import { useUser } from "@js/apps/common/hooks/use-user";
import { useFreelancerProfile } from "@js/apps/freelancer/hooks/freelancer-profile";
import { ModalInstance } from "@js/components/modal";

import { AddW8ModalContent } from "./add-w8-modal";
import { AddW9ModalContent } from "./add-w9-modal";

type TaxDocumentsModalContentProps = { showSwitchFormButton?: boolean };

const TaxDocumentsModalContent = ({
  showSwitchFormButton,
}: TaxDocumentsModalContentProps) => {
  const user = useUser();
  const freelancerProfile = useFreelancerProfile();

  const isW8FormRequired =
    freelancerProfile?.tax_form_type === ENUMS.TaxForm.W8_FORM ||
    !!user?.is_w8_form_required;
  const isW9FormRequired =
    freelancerProfile?.tax_form_type === ENUMS.TaxForm.W9_FORM ||
    !!user?.is_w9_form_required;

  if (isW9FormRequired) {
    return (
      <AddW9ModalContent
        showSwitchFormButton={showSwitchFormButton}
        closeModal={ModalInstance.close}
      />
    );
  }

  if (isW8FormRequired) {
    return (
      <AddW8ModalContent
        showSwitchFormButton={showSwitchFormButton}
        closeModal={ModalInstance.close}
      />
    );
  }

  return <></>;
};

export const openTaxDocumentsModal = ({
  showSwitchFormButton,
}: {
  showSwitchFormButton?: boolean;
} = {}) => {
  ModalInstance.open({
    closeButton: false,
    keepOnBackdropClick: true,
    children: (
      <TaxDocumentsModalContent showSwitchFormButton={showSwitchFormButton} />
    ),
  });
};
